import gql from 'graphql-tag';

export default gql`
  query schoolOrDistrictRegistrationEligibility($ncesId: String!) {
    schoolOrDistrictRegistrationEligibility(ncesId: $ncesId) {
      isEligible
      isEligibleAsIndependentSchool
      ineligibilityReason
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/SchoolRegistration/gql/schoolOrDistrictRegistrationEligibility.query.js